var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DoubleColumnLayout',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('AppPage',{attrs:{"publicId":_vm.$route.params.publicId}})]},proxy:true},{key:"right",fn:function(){return [_c('AppList',{attrs:{"excludedAppId":_vm.$route.params.publicId}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }